import DynamicTableDetail from 'components/Details/DynamicTableDetail';
import React from 'react';
import useDetallePoliza from 'redux/hooks/useDetallePoliza';

const InformacionPoliza = () => {
  const { poliza, diccionarios } = useDetallePoliza();
  return (
    <React.Fragment>
      <div className="row justify-content-center">
        <div className="col-11 col-lg-10">
          <h1>Información de la póliza</h1>
        </div>
        <div className="col-11 col-lg-10">
          <DynamicTableDetail
            source={poliza}
            diccionario={diccionarios?.detallePoliza}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default InformacionPoliza;
